export default "__VITE_ASSET__a4a4c358__"